import type { ReactNode } from 'react'

type UnsavedFieldBadgeProps = {
  /** Optional id for the screen-reader description (use with `aria-describedby` on the control). */
  describedById?: string
  className?: string
  children?: ReactNode
}

/**
 * Inline “Unsaved” pill used next to field labels on Update policy when the value
 * differs from the loaded policy and is not yet submitted.
 */
export function UnsavedFieldBadge({ describedById, className = '', children }: UnsavedFieldBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md border-2 border-yellow-500 bg-yellow-50 px-2.5 py-1 font-body text-xs font-medium text-yellow-800 ${className}`.trim()}
      role="status"
      aria-live="polite"
    >
      <span className="size-1.5 shrink-0 rounded-full bg-yellow-500" aria-hidden />
      {children ?? 'Unsaved'}
      {describedById ? (
        <span id={describedById} className="sr-only">
          Not saved on your policy until you submit with Update policy.
        </span>
      ) : null}
    </span>
  )
}
